import { defineRecipe } from "@pandacss/dev";

export const aromaDayButton = defineRecipe({
  className: "aroma-day-button",
  jsx: ["DayButton"],
  base: {
    width: "xl",
    height: "xl",
    borderRadius: "pill",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: {
      base: {
        base: "content.neutral.base.bold",
        "&[data-today]": "content.neutral.reverse.bold",
      },
      _disabled: {
        base: "content.neutral.base.disable",
        _selected: "content.functional.warning",
        "&[data-default-value]": {
          base: "content.neutral.base.bold-hover",
          _selected: "content.functional.warning",
        },
      },
      _selected: "content.brand.bold",
      "&[data-in-range]": {
        base: "content.brand.bold",
        _disabled: "content.functional.warning",
      },
    },
    borderStyle: {
      _disabled: {
        "&[data-default-value]": {
          base: "dashed",
          _selected: "solid",
        },
      },
    },
    borderWidth: {
      base: "m",
      _disabled: {
        base: 0,
        _selected: "m",
        "&[data-default-value]": { base: "xl", _selected: "m" },
      },
      "&[data-outside-range]": 0,
      "&[data-today]": {
        base: 0,
        _selected: { base: "m", _hover: { base: 0, _disabled: "m" } },
        _hover: { base: "m", _disabled: 0 },
        "&[data-focus-value]": "m",
      },
    },
    background: {
      base: {
        "&[data-today]": {
          base: "background.brand.bold",
          _disabled: "inherit",
          _hover: "background.brand.bold-hover",
        },
      },
      "&[data-in-range]": {
        base: "background.brand.subtle",
        "&[data-outside-range]": "background.neutral.base.subtlest",
        _hover: "background.brand.subtle-hover",
      },
      _selected: {
        base: "background.brand.subtle",
        _hover: "background.brand.subtle-hover",
        _disabled: {
          base: "background.functional.warning.subtle",
          _hover: "background.functional.warning.subtle",
          "&[data-outside-range]": {
            base: "background.neutral.base.subtlest",
            _hover: "background.neutral.base.subtlest",
          },
        },
      },
      _hover: {
        base: "background.neutral.base.subtlest-hover",
        "&[data-outside-range]": "inherit",
      },
    },
    borderColor: {
      base: "border.neutral.bold",
      "&[data-in-range]": {
        base: "background.brand.subtle",
        _hover: "background.brand.subtle",
      },
      "&[data-range-start], &[data-range-end]": {
        base: "border.brand-bold",
      },
      "&[data-today]": {
        base: "border.brand-bold",
        _selected: "border.brand-bold",
      },
      _selected: {
        base: "border.brand-bold",
        _hover: "border.brand-bold",
        _disabled: {
          base: "border.functional.warning",
          _hover: "border.functional.warning",
          "&[data-default-value]": {
            base: "border.functional.warning",
            _focus: "border.functional.warning",
          },
        },
      },
      "&[data-default-value]": {
        base: "border.neutral.bold",
        _focus: "border.neutral.bold",
      },
      _focus: {
        "&[data-focus-value]": {
          base: "border.brand-bold",
          _hover: "border.brand-bold",
        },
      },
      _hover: "border.neutral.bold-hover",
    },
    cursor: {
      base: "pointer",
      "&[data-outside-range]": "default",
      _disabled: "not-allowed",
    },
    boxShadow: {
      _focus: {
        "&[data-focus-value]": {
          base: "effect.focus-ring.brand",
          _disabled: "none",
        },
      },
    },
  },
});
